(() => {
  if (window.cl2HeroActionsBound) return;
  window.cl2HeroActionsBound = true;
  const visible = (el) => el.offsetHeight > 0 && getComputedStyle(el).display !== 'none';
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cl2-hero-learn]');
    if (!button) return;
    // Climb to the Shopify section wrapper (or the hero itself) and find the next visible sibling.
    let node = button.closest('.shopify-section') || button.closest('.cl2-hero-img');
    let target = null;
    while (node && !target) {
      let next = node.nextElementSibling;
      while (next && !visible(next)) next = next.nextElementSibling;
      target = next;
      node = node.parentElement;
      if (node === document.body) break;
    }
    if (!target) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
